import styled from 'styled-components';

export const StyledContainer = styled.div`
  /* Mobile Devices */
  @media (max-width: 480px) {
    min-height: 400px;
    overflow-x: hidden;
  }
`;

export const StyledGraphWrapper = styled.div`
  height: auto;
  overflow: auto;
`;

export const StyledFilterWrapper = styled.div`
  width: 100%;
  display: flex;

  /* Mobile Devices */
  @media (max-width: 480px) {
    flex-direction: column;
  }

  /* Portrait Tablets and Ipads */
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 91%;
    flex-direction: column;
  }
`;

export const StyledButtonWrapper = styled.div`
  margin-top: 27px;
  width: 16.66666667%;

  /* Mobile Devices */
  @media (max-width: 480px) {
    width: 100%;
    margin-top: 5px;
  }

  /* Portrait Tablets and Ipads */
  @media (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
    margin-top: 5px;
    margin-left: 15px;
  }
`;
